import { render, staticRenderFns } from "./AccessMethodCard.vue?vue&type=template&id=387d7700&scoped=true"
import script from "./AccessMethodCard.vue?vue&type=script&lang=js"
export * from "./AccessMethodCard.vue?vue&type=script&lang=js"
import style0 from "./AccessMethodCard.vue?vue&type=style&index=0&id=387d7700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d7700",
  null
  
)

export default component.exports